import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output, NgModule, AfterViewInit, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LocalizationService } from '@services/localization.service';
import { getStatistic, getHeadToHead, getLiveScorePage, getStatisticPage, getEndedMatchResultsPage } from '@environments/environment';

export interface DialogData {
  tournamentId: string;
  sportId: string;
  type: string;
  betradarMatchId: string;
}
declare let SIR: any;
@Component({
  selector: 'standings-dialog',
  templateUrl: '../sharedTemplates/standings.dialog.component.html',
})
export class StandingsDialogComponent implements OnInit {
  iframe_src;

  constructor(
    private domSanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<StandingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public _LZ: LocalizationService
  ) {}

  ngOnInit() {
    let url = '';
    if (this.data.type == 'statistic') {
      url = getStatistic(this._LZ.LANGCODE, this.data.sportId, this.data.tournamentId);
    } else if (this.data.type == 'headToHead') {
      url = getHeadToHead(this._LZ.LANGCODE, this.data.sportId, this.data.tournamentId, this.data.betradarMatchId);
    } else if (this.data.type == 'livescore') {
      url = getStatisticPage(this._LZ.LANGCODE);
    } else if (this.data.type == 'statistics') {
      url = getLiveScorePage(this._LZ.LANGCODE);
    } else if (this.data.type == 'endedmatchresult') {
      url = getEndedMatchResultsPage(this.data.betradarMatchId, this._LZ.LANGCODE);
    }
    this.iframe_src = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
